import { Box, rem, Image } from '@mantine/core';
import { Menu } from '@mantine/core';
import IconPencil from '@assets/icons/pencil.svg';

import styles from './CellGlobalOffsetActions.module.css';

export const CellGlobalOffsetActions = () => {
	return (
		<Box
			style={{
				display: 'flex',
				width: '26px',
				height: '25px',
			}}
		>
			<Menu shadow="xs" classNames={styles}>
				<Menu.Target>
					<Image
						style={{
							objectFit: 'contain',
							width: rem(20),
							height: rem(20),
							opacity: '0.4',
							cursor: 'not-allowed',
						}}
						src={IconPencil}
					/>
				</Menu.Target>
			</Menu>
		</Box>
	);
};
